import React from "react";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { SimpleDraftCase } from "../../types/serverSideTypes";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export interface Props {
  open: boolean;
  schools: Array<SimpleDraftCase>;
  handleClose: () => void;
  handleConfirm: () => void;
}

export default function CustomizedDialogs(props: Props) {
  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle id="customized-dialog-title" onClose={() => handleClose()}>
          <Typography
            variant="h5"
            style={{ fontFamily: "SuperaGothic-ExtraBold" }}
          >
            Submit For Review
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography
            gutterBottom
            variant="body1"
            style={{ fontWeight: "bold" }}
          >
            Are you sure you want to submit your supplements to the following
            schools for review? We will get back to you within 48 hours to make
            an offer.
          </Typography>
          {props.schools.map((school) => {
            return (
              <li style={{ fontSize: 16, fontFamily: "RobotoCondensed" }}>
                {school.schoolName}
              </li>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => props.handleConfirm()}
            color="primary"
            style={{ fontFamily: "SuperaGothic", fontWeight: "bold" }}
          >
            Confirm
          </Button>
          <Button
            autoFocus
            onClick={() => props.handleClose()}
            color="secondary"
            style={{ fontFamily: "SuperaGothic", fontWeight: "bold" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
